import useSWR from "swr"
import {API_TEAMS} from "../constants/apiUrls"

export default function useTeamHistory(teamId, teamPage) {
    const url = `${API_TEAMS}/${teamId}/history` + (teamPage ? `?limit=8&offset=${teamPage === 1 ? 0 : ((teamPage - 1) * 8)}` : "")
    const {data, mutate, error} = useSWR(url)
    return {
        teamHistory: data,
        mutateTeamHistory: mutate,
        isLoadingTeamHistory: !error && !data,
        isErrorTeamHistory: error
    }
}